import { baseURL } from "../../../constants";
import { getAuthToken } from "../../../helpers/tokenStorage";

export function useGetDownloadMusicStatisticsForLocation(locationId: number) {
    return async () => {
        const response = await fetch(
            `${baseURL}/api/auth/locations/${locationId}/music-statistics/download`,
            {
                headers: {
                    responseType: "blob",
                    Authorization: `Bearer ${
                        (getAuthToken() as any).accessToken
                    }`,
                },
            }
        );
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "locatie-muziek-lijst.csv";
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    };
}
